import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AbilityProvider } from '@core/permissions/ability'
import { RequireAuth } from './guards/RequireAuth'
import { Layout } from '@shared/components/layout/Layout'
import { VitalSignsLimitPage } from '@/features/vitalSignsLimit/pages/VitalSignsLimitPage'
import { ExpiredLinkPage } from '@/features/expiredLink/pages/ExpiredLinkPage'
import { SessionFinishedPage } from '@/features/sessionFinished/pages/SessionFinishedPage'
import { VitalsIntroductionPage } from '@/features/vitalsIntroduction/pages/VitalsIntroductionPage'
import { VitalsResults } from '@/features/vitalsResults/pages/VitalsResults'
import { Form } from '@/features/userProfileForm/pages/Form'
import {VitalsScanning} from '@/features/vitalsScanning/pages/VitalsScanning'

export default function AppRoutes() {

  return (
    <AbilityProvider>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>

            <Route path="/" element={
              <RequireAuth>
                <div>Home page</div>
              </RequireAuth>
            }/>

            <Route path="/vitalsintroduction" element={
              <RequireAuth>
                <VitalsIntroductionPage/>
              </RequireAuth>
            }/>

            <Route path="/form" element={
              <RequireAuth>
                <Form/>
              </RequireAuth>
            }/>

            <Route path="/vitalsscaning" element={
              <RequireAuth>
                <VitalsScanning/>
              </RequireAuth>
            }/>

          <Route path="/vitalsresults" element={
              <RequireAuth>
                <VitalsResults/>
              </RequireAuth>
            }/>

            <Route path="/vitalsignslimit" element={<VitalSignsLimitPage></VitalSignsLimitPage>} />
            <Route path="/expiredlink" element={<ExpiredLinkPage></ExpiredLinkPage>} />
            <Route path="/sessionfinished" element={<SessionFinishedPage></SessionFinishedPage>} />

          </Routes>
        </Suspense>
      </Layout>
    </AbilityProvider>
  )
}
